import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import { htmlWidget } from '../../Constants';
import FAQQuestion from './FAQQuestion';

class FAQ extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        const renderContent = content => {
            return { __html: content };
        };
        const hasPTag = title => {
            if (!title) return false; // handle null/empty

            const hasPTag = /<\s*p\b[^>]*>/i.test(title); // matches <p> or <p ...>
            const hasAnyTag = /<\s*\w+[^>]*>/i.test(title); // matches any HTML-like tag

            return hasPTag || !hasAnyTag;
            // return /<p\b[^>]*>(.*?)<\/p>/i.test(title);
        };
        const convertPToH2UnlessUsePTagTrue = title => {
            if (title == null) return title;

            // 1) Convert <p ...>...</p> to <h2 ...>...</h2> unless class contains "p-tag"
            const converted = title.replace(
                /<p\b([^>]*)>(.*?)<\/p>/gis,
                (match, attrs, content) => {
                    // Extract class attribute if present
                    const classMatch = attrs.match(/class\s*=\s*(['"])(.*?)\1/i);
                    const hasPTagClass = classMatch ? /\bp-tag\b/i.test(classMatch[2]) : false;

                    // If it has class "p-tag", skip conversion
                    if (hasPTagClass) {
                        return match;
                    }

                    // Otherwise convert to h2, preserving other attributes
                    const trimmedAttrs = attrs.trim();
                    return `<h2${trimmedAttrs ? ' ' + trimmedAttrs : ''}>${content}</h2>`;
                }
            );

            // 2) If there are no HTML tags at all, wrap the entire title in <h2>
            const hasAnyTag = /<\s*\w+[^>]*>/i.test(converted);
            if (!hasAnyTag) {
                return `<h2>${converted}</h2>`;
            }

            // If there are tags but no <p>, leave as-is
            return converted;
            // if(hasPTag(title)){
            //   return title.replace(/<p\b([^>]*)>(.*?)<\/p>/gi, (match, attrs, content) => {
            //     // If the p tag has class="p-tag", skip conversion
            //     if (/class\s*=\s*["']?p-tag["']?/i.test(attrs)) {
            //       return match;
            //     }
            //     return `<h2${attrs ? ' ' + attrs.trim() : ''}>${content}</h2>`;
            //   });
            // }return title;
        };
        return (
            <Row className={this.props.className}>
                <Col>
                    <div
                        className={htmlWidget + 'eir-faq-header '}
                        dangerouslySetInnerHTML={renderContent(
                            convertPToH2UnlessUsePTagTrue(this.props.title)
                        )}
                    />
                    {/* <h3 className="eir-faq-header">{this.props.title}</h3> */}
                    <div id="accordion" className="eir-faq">
                        {this.props.faqs.map((faq, index) => {
                            return (
                                <FAQQuestion
                                    key={`faq-${index}`}
                                    {...faq}
                                    id={index}
                                    collapse={this.props.collapse}
                                />
                            );
                        })}
                    </div>
                </Col>
            </Row>
        );
    }
}

export default FAQ;
